import React from "react";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import MaterialRequestOverview from "../../shared/materialRequests/MaterialRequestOverview";
import { getRegistrationMaterialCategories } from "../../../services/api/registrationMaterialCategories";
import { connect } from "react-redux";
import { selectCompanyRegistration } from "../../../redux/preferences/selectors";
import PropTypes from "prop-types";
import { MaterialRequestOverviewNew } from "../../shared/materialRequests/MaterialRequestOverviewNew";

class _CompanyMaterialOverview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      materialCategories: []
    };
  }

  static propTypes = {
    registration: PropTypes.object
  };

  UNSAFE_componentWillMount() {
    getRegistrationMaterialCategories(this.props.registration.id).then(
      response => {
        const materialCategories = response.data.map(
          cat => cat.materialCategoryId
        );

        this.setState({
          materialCategories
        });
      }
    );
  }

  render() {
    return [
      <AdminSubHeader title="Material" key="subheader" breadcrumbs={[]} />,
      <div key="tvh">
        {this.state.materialCategories.indexOf(6) !== -1 && (
          <div>
            <div
              className="m-alert m-alert--icon alert alert-brand m--margin-top-20"
              role="alert"
            >
              <div className="m-alert__icon">
                <img src="/assets/img/tvh.png" alt="" style={{ width: 100 }} />
              </div>
              <div className="m-alert__text">
                <strong>Looking for machinery*?</strong> If you wish to request
                machinery, please proceed to MyAssetPlanner.
                <br /> No account yet? Contact{" "}
                <a
                  href="mailto:myassetplanner@tvh.com"
                  style={{ textDecoration: "underline", color: "white" }}
                >
                  myassetplanner@tvh.com
                </a>
                 with your name and company.
              </div>
              <div className="m-alert__actions" style={{ width: 200 }}>
                <a
                  className="btn btn-outline-light btn-sm m-btn m-btn--hover-brand"
                  href="https://myassetplanner.tvh.com"
                >
                  Go to MyAssetPlanner
                </a>
              </div>
            </div>
            <p style={{ opacity: 0.7 }}>
              * If you want to request machinery for DreamVille, please email to{" "}
              <a href="mailto:machines@dreamville.be">machines@dreamville.be</a>{" "}
              for machinery and{" "}
              <a href="mailto:electro@dreamville.be">electro@dreamville.be</a>{" "}
              for utilities.
            </p>
          </div>
        )}
      </div>,
      <MaterialRequestOverviewNew
        key="content"
        event={this.props.registration.event}
      />
    ];
  }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = function(state) {
  return {
    registration: selectCompanyRegistration(state)
  };
};

const CompanyMaterialOverview = connect(
  mapStateToProps,
  mapDispatchToProps
)(_CompanyMaterialOverview);

export default CompanyMaterialOverview;
